import { useCallback } from 'react'

import { api } from 'app/api'
import { POST_TRANSFER, convertParams, convertResult } from 'app/common/api/requests/cabinet/cafeteria/payments/transfer/post'
import { Params } from 'app/dataTypes/transfer'


export function useTransfer() {
  const transfer = useCallback(async (params: Params) => {
    const res = await api.request(POST_TRANSFER, {
      error: 'Не удалось отправить средства',
      params,
      convertions: {
        convertParams,
        convertResult,
      },
    })
    return !!res
  }, [])

  return transfer
}
